import Marquee from "react-fast-marquee";
import { useLang } from "../i18n/LanguageContext";

export default function Ribbon() {
  const { t } = useLang();
  return (
    <div data-testid="services-ribbon" className="bg-[#1e2a6e] py-5 border-y border-white/10">
      <Marquee speed={40} gradient={false} autoFill>
        {t.ribbon.map((item, i) => (
          <div key={i} className="flex items-center">
            <span className="font-heading text-white font-bold tracking-tight text-lg sm:text-2xl px-8">
              {item}
            </span>
            <span className="text-[#4a90d9] text-2xl">✦</span>
          </div>
        ))}
      </Marquee>
    </div>
  );
}
